import React, { Component } from 'react'
import { RFC_FORMAT, FORMAT_NUMBER, FULLNAME_FORMAT, ZIPCODE, STREET_FORMAT, BLOCK_FORMAT, CITY_FORMAT } from "../libs/utils/Const";
import $ from 'jquery';

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

class ValidateDocFieldsModal extends Component {

    refreshModel = (updatebusinessPartner) => {
        const { RefreshBusinessModel } = this.props;
        RefreshBusinessModel(updatebusinessPartner);
    };

    ChangeAddressStreet = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToStreet = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToStreet = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressBlock = (value, pointer) => {
        const { updatebusinessPartner, refreshModel, newOrderModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToBlock = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToBlock = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressCity = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToCity = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToCity = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressZipCode = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel, showAlert } = this.props;
        if (isNaN(value)) {
            showAlert({ type: "warning", message: "INGRESA UN VALOR VALIDO PARA CP", timeOut: 5000 });
            return;
        }
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToZipCode = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToZipCode = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };


    ChangeAddressState= (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.BillToState = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToState = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeLicTradNum = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        updatebusinessPartner.LicTradNum = value;
        newOrderModel.LicTradNum = value;
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeCardName = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        updatebusinessPartner.CardName = value;
        newOrderModel.CardName = value;
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    render() {
        const { newOrderModel, CFDI, CreateDocument, states, RegimenFiscal, ChangeUSOCFDI, ChangeRegimenFiscal } = this.props;
        
        return (
            <>
                <div className="modal fade" id="validateDocFIelds" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="validateDocFIelds" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" id="advanced-search-form">
                                    <div className="row">
                                        <div className="col-md-12 text-left mt-2">
                                            <h4>Datos del documento</h4>
                                        </div>
                                        <div className="col-md-6 text-right">

                                        </div>
                                    </div>

                                    <form>
                                        <div className="row mb-2">
                                            <div className="col-md-12">
                                                <div id="grupo__fullName">
                                                    <label htmlFor="full-name">Nombre completo</label>
                                                    <i data-toggle="tooltip" data-placement="right" title="Solo letras, min 3 y max 100 (evite los caracteres especiales)." className={!FULLNAME_FORMAT.test(newOrderModel?.CardName ?? "") ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Nombre"
                                                            value={newOrderModel?.CardName ?? ""}
                                                            onChange={(event) => this.ChangeCardName(event.target.value)}
                                                        // onBlur={this.ValidateFullName}
                                                        />
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 100.</p>
                                                    <p className="form__input-void">Nombre no puede ir vació.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className="input-group ">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <strong>RUT:</strong>
                                                            <i data-toggle="tooltip" data-placement="right" title={"No puede ir vacio. Formato valido: (XAXX010101000)"} 
                                                            className={!RFC_FORMAT.test(newOrderModel?.LicTradNum ?? '') ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={newOrderModel?.LicTradNum ?? ''}
                                                        onChange={(event) => this.ChangeLicTradNum(event.target.value)}

                                                    />
                                                </div>

                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className='col-md-12'>
                                                <div className="input-group mt-2">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <strong>Regimen fiscal:</strong>
                                                            <i data-toggle="tooltip" data-placement="right" title="Selecciona uno" className={(newOrderModel?.RegimenFiscal ?? "") == "" ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                        </span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        id="taxSystem"
                                                        value={newOrderModel?.RegimenFiscal ?? ""}
                                                        onChange={(event) => ChangeRegimenFiscal(event.target.value)}
                                                    // onBlur={this.ValidateTaxSystem}
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {RegimenFiscal && RegimenFiscal.map((regimenFiscal) => {
                                                            return (
                                                                <option value={regimenFiscal.FldValue}>{regimenFiscal.Descr}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row mb-2 mt-2'>
                                            <div className='col-md-12'>
                                                <div className="input-group" >
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">
                                                            <strong>Uso de CFDI:</strong>
                                                            <i data-toggle="tooltip" data-placement="right" title="Selecciona uno" className={(newOrderModel?.USOCFDI ?? "")== "" ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                        </span>
                                                    </div>
                                                    <select
                                                        name="select"
                                                        className="form-control"
                                                        id="selectProject"
                                                        value={newOrderModel?.USOCFDI ?? ""}
                                                        onChange={(event) => ChangeUSOCFDI(event.target.value)}
                                                    // onBlur={this.ValidateUCFDI}
                                                    >
                                                        <option value="">Seleccionar</option>
                                                        {CFDI && CFDI.map((cfdi) => {
                                                            return (
                                                                <option value={cfdi.FldValue}>{cfdi.Descr}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>

                                        </div>

                                        <section>
                                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link active" id="billDirection-tab" data-toggle="tab" href="#billDirection" role="tab" aria-controls="billDirection" aria-selected="false" style={{ color: "black" }} >
                                                        <h6>Dir. Facturación</h6>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none", }}>

                                                {/*  ------------------------------------------ CUENTA ----------------------------------------------- */}
                                                {
                                                    <div className="tab-pane fade active show" id="billDirection" role="tabpanel">
                                                        <form className='ml-2 mr-2 mt-2'>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="form-group" id="grupo__street1">
                                                                        <label htmlFor="firstName">Calle y Número</label>
                                                                        <i data-toggle="tooltip" data-placement="right" title={"No puede ir vacio. De 4 a 100 letras y/o numeros, evite caracteres especiales"} className={!STREET_FORMAT.test(newOrderModel?.AddressExtension?.BillToStreet ?? '') ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                                        <div className="form__group-input">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form__input"
                                                                                placeholder="Calle y Número"
                                                                                id='street1'
                                                                                value={newOrderModel?.AddressExtension?.BillToStreet ?? ''}
                                                                                onChange={(event) => this.ChangeAddressStreet(event.target.value, "B")}
                                                                                // onBlur={this.ValidateStreet}
                                                                            />
                                                                            <i className="form__validation-state fa fa-times-circle"></i>
                                                                        </div>
                                                                        <div className="form-group formulario__grupo" id="grupo__street1">
                                                                            <p className="form__input-error" style={{ marginTop: "-1px" }}>{"De 4 a 100 letras y/o numeros"}</p>
                                                                            <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="form-group formulario__grupo" id="grupo__block1">
                                                                        <label htmlFor="cardCode">Colonia</label>
                                                                        <i data-toggle="tooltip" data-placement="right" title={"No puede ir vacio. De 4 a 100 letras y/o numeros, evite caracteres especiales"} className={!BLOCK_FORMAT.test(newOrderModel?.AddressExtension?.BillToBlock ?? '') ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                                        <div className="form__group-input">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form__input"
                                                                                placeholder="Colonia"
                                                                                id='block1'
                                                                                value={newOrderModel?.AddressExtension?.BillToBlock ?? ''}
                                                                                onChange={(event) => this.ChangeAddressBlock(event.target.value, "B")}
                                                                            // onBlur={this.ValidateBlock}
                                                                            />
                                                                            <i className="form__validation-state fa fa-times-circle"></i>
                                                                        </div>
                                                                        <div className="form-group formulario__grupo" id="grupo__block1">
                                                                            <p className="form__input-error" style={{ marginTop: "-1px" }}>{"De 4 a 100 letras y/o numeros"}</p>
                                                                            <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="form-group formulario__grupo" id="grupo__city1">
                                                                        <label htmlFor="city1">Ciudad</label>
                                                                        <i data-toggle="tooltip" data-placement="right" title={"No puede ir vacio. De 4 a 100 letras y/o numeros, evite caracteres especiales"} className={!CITY_FORMAT.test(newOrderModel?.AddressExtension?.BillToCity ?? '') ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                                        <div className="form__group-input">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form__input"
                                                                                placeholder="Ciudad"
                                                                                id='city1'
                                                                                value={newOrderModel?.AddressExtension?.BillToCity ?? ''}
                                                                                onChange={(event) => this.ChangeAddressCity(event.target.value, "B")}
                                                                            // onBlur={this.ValidateCity}
                                                                            />
                                                                            <i className="form__validation-state fa fa-times-circle"></i>
                                                                        </div>
                                                                        <div className="form-group formulario__grupo" id="grupo__city1">
                                                                            <p className="form__input-error" style={{ marginTop: "-1px" }}>{"De 4 a 100 letras y/o numeros"}</p>
                                                                            <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6">
                                                                    <div className="form-group formulario__grupo" id="grupo__pc">
                                                                        <label htmlFor="pc1">Código postal</label>
                                                                        <i data-toggle="tooltip" data-placement="right" title={"No puede ir vacio. Son 5 números"} className={!ZIPCODE.test(newOrderModel?.AddressExtension?.BillToZipCode ?? '') ? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                                        <div className="form__group-input">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control form__input"
                                                                                placeholder="C.P."
                                                                                id="pc"
                                                                                value={newOrderModel?.AddressExtension?.BillToZipCode ?? ''}
                                                                                onChange={(event) => this.ChangeAddressZipCode(event.target.value, "B")}
                                                                            // onBlur={this.ValidateZipCode}
                                                                            />
                                                                            <i className="form__validation-state fa fa-times-circle"></i>
                                                                        </div>
                                                                        <div className="form-group formulario__grupo" id="grupo__pc">
                                                                            <p className="form__input-error" style={{ marginTop: "-1px" }}>{"Son 5 números"}</p>
                                                                            <p className="form__input-void" style={{ marginTop: "-1px" }}>El código postal no puede ir vació.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-6">
                                                                    <div className="form-group form__group-input">
                                                                        <label htmlFor="state1">Estado </label>
                                                                        <i data-toggle="tooltip" data-placement="right" title="Selecciona uno" className={(newOrderModel.AddressExtension?.BillToState ?? '') == ""? "form__input-error-active fa fa-info-circle ml-2" : ""}></i>
                                                                        <select
                                                                            name="stateS"
                                                                            className="form-control form__input"
                                                                            id='state1'
                                                                            value={newOrderModel.AddressExtension?.BillToState ?? ''}
                                                                            onChange={(event) => this.ChangeAddressState(event.target.value, "B")}
                                                                            // onBlur={this.ValidateState}
                                                                        >
                                                                            <option value="">Estado</option>
                                                                            {states && states.length > 0 && states.map((state) => (
                                                                                state.Country === "MX" ?
                                                                                    <option key={state.Code} value={state.Name} >
                                                                                        {state.Name}
                                                                                    </option> : ""
                                                                            ))}
                                                                        </select>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>

                                                    </div>
                                                }
                                            </div>
                                        </section>
                                    </form>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row">
                                        <>

                                            {/* <button type="button"
                                                className="btn-lg btn-secondary col-3 ml-2 mr-2"
                                                data-toggle="modal" 
                                                // onClick={() => this.ResetValidations(EditBusinessPartner)}
                                            >
                                                Cancelar Doc
                                            </button> */}
                                            <button type="button"
                                                className="btn-lg btn-primary d-block w-100 col-12 ml-1"
                                                onClick={() => CreateDocument(false)}
                                            >
                                                Continuar
                                            </button>
                                        </>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

            </>
        );
    }
}

export default ValidateDocFieldsModal